/* ─────────────────────────────────────────────────────────────
   金の目 オンラインショップ — 動きの再現
   数値はすべて実測値（出典は社内資料に記録してある）。
   参考サイトはライブラリで動いているが、ここでは同じ「見え方」を素の JS で作る。
   ライブラリは足さない。
   🔴 このファイルは Shopify のテーマへ上がり、**ソースマップが公開配信される**
      （kinnome.com/cdn/shop/t/<n>/assets/kinnome.js.map・認証不要）。
      参考サイト名・土台テーマ名・社内パスをここに書かないこと（2026-09-29 に実際に露出していた）。
   ───────────────────────────────────────────────────────────── */
(function () {
  "use strict";

  var reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  /* ① 読み込み演出 — body を 0→1 で 250ms ease-in-out（実測）。
        JS が落ちても真っ白にならないよう、CSS 側の既定は opacity 1 にしてある。
        ここで一度 `is-loading` を付けてから外すことで演出だけを足す。 */
  if (!reduce) {
    document.body.classList.add("is-loading");
    requestAnimationFrame(function () {
      requestAnimationFrame(function () { document.body.classList.remove("is-loading"); });
    });
  }

  /* ② ヘッダー — scrollY >= 1 で縮む。
        しきい値は 1px 刻みで走査して、遷移点が 1 箇所だけと確認済み。
        隠れる挙動は無い。scroll は毎フレーム走るので rAF で束ねる。 */
  var header = document.querySelector("[data-header]");
  if (header) {
    var ticking = false;
    var applyHeader = function () {
      header.classList.toggle("is-compact", window.scrollY >= 1);
      ticking = false;
    };
    applyHeader();
    window.addEventListener("scroll", function () {
      if (!ticking) { ticking = true; requestAnimationFrame(applyHeader); }
    }, { passive: true });
  }

  /* ③ ヒーロー — 4000ms ごとに 400ms のクロスフェード（実測 周期 4403ms）。
        本家にドットも矢印も出ていないので操作 UI は作らない。
        タブが隠れているあいだは進めない（戻ったとき一気に飛ぶのを避ける）。 */
  var hero = document.querySelector("[data-hero]");
  if (hero) {
    var slides = [].slice.call(hero.querySelectorAll(".hero__slide"));
    if (slides.length > 1) {
      var index = 0, timer = null;
      var INTERVAL = 4000; // slick の autoplaySpeed（切替 400ms は CSS 側）

      var show = function (next) {
        slides[index].classList.remove("is-active");
        index = (next + slides.length) % slides.length;
        slides[index].classList.add("is-active");
      };
      var start = function () {
        if (timer || reduce) return;
        timer = window.setInterval(function () { show(index + 1); }, INTERVAL);
      };
      var stop = function () {
        if (!timer) return;
        window.clearInterval(timer); timer = null;
      };

      document.addEventListener("visibilitychange", function () {
        if (document.hidden) stop(); else start();
      });
      start();
    }
  }

  /* ④ ドロワー — 左から 250ms ease-in-out。外枠 320px / 内側 230px。
        本家のトグルを実際に押して測り直した結果、次の4つが分かっている:
          ・暗幕は無い
          ・背面ロックはする（body overflow hidden。ホイールでも動かないことを確認）
          ・**ページごと右へ 320px 押し出す**（SP は 100vw）。ヘッダーもフッターも動く
          ・閉じる操作は**ヘッダーのボタンそのもの**。その場に残って（x=80→400 と
            ページと一緒に移動して）字だけ ☰ → ✕ に変わる。専用の閉じるボタンは
            デスクトップでは出ていない
        押した指／焦点はボタンの上に留まるので、開いたあと閉じる操作へ自然に戻れる。 */
  var drawer = document.querySelector("[data-drawer]");
  var page = document.querySelector("[data-page]");
  var toggle = document.querySelector("[data-drawer-toggle]");
  // ☰ は 3 本線の CSS で描いていて、開くと ✕ に変形する（`aria-expanded` で切り替わる）。
  // 字を差し替えていた頃の名残りで glyph を触っていたが、もう要らない。
  if (drawer && toggle) {
    var setDrawer = function (open) {
      drawer.classList.toggle("is-open", open);
      if (page) page.classList.toggle("is-pushed", open);
      toggle.setAttribute("aria-expanded", open ? "true" : "false");
      toggle.setAttribute("aria-label", open ? "メニューを閉じる" : "メニューを開く");
      document.body.style.overflow = open ? "hidden" : "";
    };

    toggle.addEventListener("click", function () {
      setDrawer(!drawer.classList.contains("is-open"));
    });
    // 768px 未満はドロワーの右上にも閉じるボタンが出る（本家と同じ）。
    var closer = drawer.querySelector("[data-drawer-close]");
    if (closer) closer.addEventListener("click", function () { setDrawer(false); });

    /* 🔴 2026-09-07 追加 — **同じページの中へ飛ぶリンクを押したら閉じる**。
       ドロワーの項目はほとんどが `#products` `#category` のページ内リンク。
       閉じないと、飛んだ先の上にドロワーが乗ったまま `body { overflow: hidden }` が
       残り、**商品一覧をスクロールできない**（実測: scrollY が 3001 から動かなかった）。
       別ページへ出るリンクは遷移するので触らない。 */
    drawer.addEventListener("click", function (e) {
      var a = e.target.closest ? e.target.closest("a[href]") : null;
      if (!a) return;
      var href = a.getAttribute("href") || "";
      // ページ内リンク（#... / 同じパスの #...）だけを対象にする
      var samePage = href.charAt(0) === "#" ||
        (a.pathname === window.location.pathname && a.hash && a.host === window.location.host);
      if (samePage) setDrawer(false);
    });
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && drawer.classList.contains("is-open")) setDrawer(false);
    });
  }

  /* ⑤ スクロールで浮かび上がる — 発火は `rect.top < window.innerHeight`。
        本家は jQuery のスクロールイベント（100ms スロットル）+ jquery.visible。
        ここも同じ方式にする。IntersectionObserver では駄目だった:
        アンカー移動や一気のスクロールで**通り過ぎた要素に通知が来ず**、
        中身が opacity 0 のまま残る（13件中5件が残るのを実測）。
        本家の「毎回すべての未発火要素を測り直す」やり方にはこの穴が無い。 */
  var pending = [].slice.call(document.querySelectorAll(".reveal"));
  if (pending.length) {
    if (reduce) {
      pending.forEach(function (el) { el.classList.add("is-in"); });
    } else {
      // 遅延の決め方。本家は **同じ行のものは同時に出す**（商品は3列なので3枚ずつ）。
      // 並び順だけで 250ms ずつずらすと、1行の中で左から順に出て本家と違う動きになる。
      // 行は画面上の縦位置で判定するので、列数が変わる幅でも自動で追従する。
      pending.forEach(function (el) {
        var sibs = [].slice.call(el.parentNode.children).filter(function (n) {
          return n.classList && n.classList.contains("reveal");
        });
        var tops = sibs.map(function (n) { return Math.round(n.getBoundingClientRect().top); });
        var uniq = tops.filter(function (v, i) { return tops.indexOf(v) === i; }).sort(function (a, b) { return a - b; });
        var row = uniq.indexOf(tops[sibs.indexOf(el)]);
        var step = Math.min(row, 4); // 実測の刻みは 0/250/500/750/1000 の5段まで
        el.style.setProperty("--reveal-delay", (step * 250) + "ms");
      });

      var sweep = function () {
        var vh = window.innerHeight;
        pending = pending.filter(function (el) {
          if (el.getBoundingClientRect().top >= vh) return true; // まだ画面下端に触れていない
          el.classList.add("is-in");
          return false; // 一度出したら二度と測らない
        });
        if (!pending.length) {
          window.removeEventListener("scroll", onScroll);
          window.removeEventListener("resize", onScroll);
        }
      };

      // 本家と同じ 100ms のスロットル。末尾も必ず1回走らせる。
      var last = 0, trailing = null;
      var onScroll = function () {
        var now = Date.now();
        if (now - last >= 100) { last = now; sweep(); }
        else {
          window.clearTimeout(trailing);
          trailing = window.setTimeout(function () { last = Date.now(); sweep(); }, 100);
        }
      };

      window.addEventListener("scroll", onScroll, { passive: true });
      window.addEventListener("resize", onScroll, { passive: true });
      sweep(); // 読み込み直後に画面内にあるぶんを出す
    }
  }
})();
